import { ADD_PATH_CACHE, REMOVE_PATH_CACHE, PURGE_PATH_CACHE, CLEAR_PATH_CACHES } from "./types"

/**
 * @param {object} payload
 * @param {string} payload.key - required
 * @param {string[]} payload.allowedPathnames - required
 * @param {number?} payload.scrollTop
 * @param {object?} payload.data - The data to be saved. Typically, the state variable name is used as the key value, but it doesn't have to be.
 */
export const addPathCache = (payload) => ({
  type: ADD_PATH_CACHE,
  payload
})

/**
 * @param {object} payload
 * @param {string} payload.key - required
 */
export const removePathCache = (payload) => ({
  type: REMOVE_PATH_CACHE,
  payload
})

/**
 * @param {object} payload
 * @param {string} payload.pathname - If not specified, delete all.
 */
export const clearPathCaches = (payload) => ({
  type: CLEAR_PATH_CACHES,
  payload
})
